export const METRIC_CONFIGS = {
  'Estimated commission from paid services': {
    inputs: [
      {
        key: 'customerMonthlyDemand',
        label: 'Customer Monthly Demand'
      }
    ]
  },
  'Estimated savings from redirecting returns': {
    inputs: [
      {
        key: 'monthlyVolumeForReturns',
        label: 'Monthly Volume for Returns due to size/fit'
      }
    ]
  },
  'Estimated savings from repairing in store defects': {
    inputs: [
      {
        key: 'annualProductionVolumes',
        label: 'Annual Production Volumes'
      },
      {
        key: 'defectivePct',
        label: '% of Products that are Defective',
        suffix: '%',
        max: 100
      }
    ]
  },
  'Estimated savings from reducing warranty exchanges': {
    inputs: [
      {
        key: 'defectiveClaims',
        label: 'Monthly Volume for Defective Items claims'
      }
    ]
  },
  'Estimated revenue from increased repurchases': {
    inputs: [
      {
        key: 'customerMonthlyDemand',
        label: 'Customer Monthly Demand'
      },
      {
        key: 'brandCurrentRepurchaseRate',
        label: "% Brand's Current Repurchase Rate",
        suffix: '%',
        max: 100
      }
    ]
  },
  'Estimated revenue & savings from retaining younger customers': {
    inputs: [
      { key: 'totalNoOfCustomers', label: 'Total No. of Customers', step: 100 },
      {
        key: 'customersUnder35Pct',
        label: '% of customers <35',
        suffix: '%',
        max: 100
      },
      {
        key: 'repurchaseRateOfCustomersUnder35',
        label: '% Current Repurchase Rate of customers <35',
        suffix: '%',
        max: 100
      }
    ]
  },
  'Estimated savings from reducing team workload': {
    inputs: [
      {
        key: 'customerMonthlyDemand',
        label: 'Customer Monthly Demand',
        step: 100
      },
      {
        key: 'avgCostPerEmployee',
        label: 'Avg cost per hour per ',

        suffix: '€'
      }
    ]
  }
};

export default METRIC_CONFIGS;
